import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Centros de Custo", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-20" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-17" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_15 = { class: "ant-col ant-col-xs-8 ant-col-xl-4" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Número"
}, "Número", -1)
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_plano_conta = _resolveComponent("selecionar-plano-conta")!
  const _component_selecionar_credito_debito = _resolveComponent("selecionar-credito-debito")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_tipo_categoria_plano_conta = _resolveComponent("selecionar-tipo-categoria-plano-conta")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_conta_contabil_referenciada = _resolveComponent("selecionar-conta-contabil-referenciada")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_plano_conta_categoria_centros_custo_modal = _resolveComponent("plano-conta-categoria-centros-custo-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      style: {"width":"900px"},
      centered: "",
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Categoria do Plano de Contas "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.categoria.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.categoria.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativa",
          "un-checked-children": "Inativa"
        }, null, 8, ["checked"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.abrirCentrosCustos()))
            }, _hoisted_2),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-secondary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(true)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.salvar(false)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
            ])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                (_ctx.props.planoContas > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria Pai",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                value: _ctx.state.categoria.codigoPlanoContaCategoriaPai,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.categoria.codigoPlanoContaCategoriaPai) = $event)),
                                codigoPlanoConta: _ctx.state.categoria.codigoPlanoConta,
                                tipoPlanoConta: 0,
                                ignorarCategorias: [_ctx.state.categoria.codigo],
                                tipoCategoria: 'S',
                                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.obterProximoNumeroConta(true)))
                              }, null, 8, ["value", "codigoPlanoConta", "ignorarCategorias"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_a_form_item, {
                            label: "Código",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.categoria.codigo) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.state.categoria.codigo]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_a_form_item, {
                            label: "Plano de Contas",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_plano_conta, {
                                codigoSelecionado: _ctx.state.categoria.codigoPlanoConta,
                                "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.categoria.codigoPlanoConta) = $event)),
                                empresas: _ctx.telaBase.empresasSelecionadas,
                                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.atualizarMascaraConta()))
                              }, null, 8, ["codigoSelecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria Pai",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                codigoSelecionado: _ctx.state.categoria.codigoPlanoContaCategoriaPai,
                                "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.categoria.codigoPlanoContaCategoriaPai) = $event)),
                                codigoPlanoConta: _ctx.state.categoria.codigoPlanoConta,
                                ignorarCategorias: [_ctx.state.categoria.codigo],
                                tipoCategoria: 'S',
                                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.obterProximoNumeroConta(true)))
                              }, null, 8, ["codigoSelecionado", "codigoPlanoConta", "ignorarCategorias"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_a_form_item, {
                      label: "Nome",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.categoria.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.categoria.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, {
                      label: "Natureza",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_credito_debito, {
                          valor: _ctx.state.categoria.natureza,
                          "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.categoria.natureza) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_form_item, {
                      label: "Mostrar no balanço",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_sim_nao, {
                          class: "ss-tamanho-completo",
                          radioButton: true,
                          valor: _ctx.state.categoria.balancete,
                          "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.categoria.balancete) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_tipo_categoria_plano_conta, {
                          valor: _ctx.state.categoria.tipo,
                          "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.categoria.tipo) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.verificaApresentacaoCategoriaAnalitica()?'ant-col ant-col-xs-24 ant-col-xl-10':'ant-col ant-col-xs-24 ant-col-xl-18')
                  }, [
                    _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                      label: _withCtx(() => [
                        _hoisted_18,
                        ((_ctx.state.categoria.codigo === 0 || _ctx.state.categoriaPaiAlterada))
                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 0,
                              placement: "top",
                              title: "O número gerado abaixo é uma prévia para você visualizar como ficará a hierarquia do seu plano de contas, ao concluir o cadastro e se ele não estiver disponível, será gerado um novo número."
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-informacao-campo",
                                  nome: "informacao-campo"
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createElementBlock("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.categoria.numero) = $event)),
                          disabled: "",
                          key: _ctx.state.categoria.numero
                        })), [
                          [_directive_maska, _ctx.state.mascaraConta],
                          [_vModelText, _ctx.state.categoria.numero]
                        ])
                      ]),
                      _: 1
                    })
                  ], 2),
                  _withDirectives(_createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, {
                      label: "Conta Reduzida",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "ant-input",
                          style: {"text-align":"right"},
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.categoria.contaReduzida) = $event)),
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.state.categoria.contaReduzida]
                        ])
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.verificaApresentacaoCategoriaAnalitica()]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, {
                      label: "Conta Contábil Referenciada",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_conta_contabil_referenciada, {
                          codigoSelecionado: _ctx.state.categoria.codigoContaContabilReferenciada,
                          "onUpdate:codigoSelecionado": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.categoria.codigoContaContabilReferenciada) = $event)),
                          empresas: _ctx.telaBase.empresasSelecionadas
                        }, null, 8, ["codigoSelecionado", "empresas"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          retornoRequisicao: _ctx.modalBase.retornoRequisicao,
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
        }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
        _createVNode(_component_plano_conta_categoria_centros_custo_modal, {
          visivel: _ctx.state.mostrarCentrosCusto,
          "onUpdate:visivel": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.mostrarCentrosCusto) = $event)),
          centrosCusto: _ctx.state.centrosCusto,
          "onUpdate:centrosCusto": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.centrosCusto) = $event))
        }, null, 8, ["visivel", "centrosCusto"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}